<template>
	<div class="documentBox">
		<h1 class="documentTitle">{{menuData.title}}</h1> 
    <div v-if="menuData" class="documentInfoBox">
      <div class="documentInfo" >
        <div class="documentText">
          <div class="blurb">
            <h5>简介</h5>
            <div  v-if="menuData.state==1">
              <p>当前发布版本：{{menuData.versionName}}</p>
              <p>发布时间：{{menuData.publishTime | parseTime()}}</p>
            </div>
            <div v-else>
              <p>未发布文档</p>
            </div>
          </div>
        </div>
        <div class="buttonBox">
          <el-button type="primary" @click="onCreateDocument()" >
            上传文档
          </el-button>
        </div>
      </div>
      <div v-if="tableData.length" class="dataListBox">
        <div class="height400">
          <el-table 
          :data="tableData"
          class="tableBox"
          header-row-class-name="tableBox-bg"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }">
            <el-table-column  label="序号" type="index" >
            </el-table-column>
            <el-table-column prop="versionName" label="版本" >
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.publishState==1">未发布</span>
                <span v-if="scope.row.publishState==2">定时发布</span>
                <span v-if="scope.row.publishState==3">已发布</span>
                <span v-if="scope.row.publishState==4">下架</span> 
              </template>
            </el-table-column>
            <el-table-column prop="desc" label="文档描述" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="adminName" label="上传人" width="100">
            </el-table-column>
            <el-table-column prop="createTime" label="上传时间" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.createTime | parseTime() }}</span>
              </template> 
            </el-table-column>
            <el-table-column width="150" prop="address" label="操作">
              <template slot-scope="scope">
                <template>
                  <el-button v-if="scope.row.publishState==1 || scope.row.publishState==2"  class="color-blue link-button" type="text" @click="onEditDocument(scope.row)">编辑</el-button>
                  <el-button v-if="scope.row.publishState==3"  class="color-blue link-button" type="text" @click="offShelfPDFCenter(scope.row)">下架</el-button>
                  <el-button v-if="scope.row.publishState==4"  class="color-blue link-button" type="text" @click="publishPDFCenter(scope.row)">发布</el-button>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="text-right margin-t30">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="searchFormData.perPage"
            :current-page="searchFormData.page"
            layout="total, prev, pager, next, sizes"
            :total="total"
          ></el-pagination>
        </div>
      </div>
      <div v-else class="list-no text-center" >
        <div class="list-msg">当前标题没有文档，请先上传文档</div>
      </div>
    </div>
    <publis-document ref="modalRef" :menuData="menuData" @queryPDFCenterList="queryPDFCenterList()"></publis-document>
	</div>
</template>

<script>
import publisDocument from '../dialogs/publisDocument';
export default {
  components: {publisDocument},
  computed: {
    userInfo() {
      return this.$store.getters["accountStore/getUserInfo"]; //获取用户信息
    },
  },
  watch: {
    '$route.query.pdfMenuId' () {
      this.queryPDFCenterList();
      this.queryPDFMenuDetail();
    },
    '$route.query.date' () {
      this.queryPDFCenterList();
      this.queryPDFMenuDetail();
    },
  },
	data(){
		return{
      searchFormData: {
        page: 1,
        perPage: 10,
      },
			tableData:[],//文档列表
      menuData:'',//菜单数据
      isEditAuthor:false,
		}
	},
	created(){
    this.queryPDFCenterList();
    this.queryPDFMenuDetail();
  },
	methods:{
    offShelfPDFCenter(item) {
        this.$dialogs.confirm({
          title:`<span style="color:#D71F1F;">确定下架《${item.versionName}》？</span>`,
          content: `下架后节点《${this.menuData.title}》将变为未发布状态`,
        }).then(() => {
          this.$apis.documentPDFServer.offShelfPDFCenter({
            pdfMenuId:this.$route.query.pdfMenuId,
            id:item.id,
          }).then(res=>{
            if (res['code'] == 0){
              this.$message.success('下架成功');
              window.location.reload();
            }
          })
        }).catch((val) => {});
    },
    publishPDFCenter(item) {
        this.$dialogs.confirm({
          title:`<span style="color:#D71F1F;">确定发布《${item.versionName}》？</span>`,
          content: `发布后节点《${this.menuData.title}》将变为已发布状态`,
        }).then(() => {
          this.$apis.documentPDFServer.publishPDFCenter({
            pdfMenuId:this.$route.query.pdfMenuId,
            id:item.id,
          }).then(res=>{
            if (res['code'] == 0){
              this.$message.success('发布成功');
              window.location.reload();
            }
          })
        }).catch((val) => {});
    },
    onCreateDocument() {
      this.$refs.modalRef.show()
    },
    onEditDocument(item) {
      this.$refs.modalRef.show(item.id)
    },
		//获取菜单详情
    queryPDFMenuDetail(){
      this.$apis.documentPDFServer.queryPDFMenuDetail({id:this.$route.query.pdfMenuId}).then(res=>{
        if (res['code'] == 0){
          this.menuData = res.data;
        }
      })
    },
    //获取文档列表
    queryPDFCenterList(data=''){
      if (data) {
        this.searchFormData.page = 1
      }
      this.$apis.documentPDFServer.queryPDFCenterList({
        ...this.searchFormData,
        pdfMenuId:this.$route.query.pdfMenuId,
      }).then(res=>{
        if (res['code'] == 0 ){
          if(typeof res.data.data !='undefined' ){
            this.total = res.data.total
            this.tableData = res.data.data;
          }else{
            this.total = 1;
            this.tableData = [];
          }
        }else{
          this.total = 1;
          this.tableData = [];
          this.$message.error(res.message);
        }
      })
    },
    handleSizeChange(val) {
      this.searchFormData.perPage = val;
      this.queryPDFCenterList();
    },
    handleCurrentChange(val) {
      this.searchFormData.page = val;
      this.queryPDFCenterList();
    },
	}
}
</script>

<style scoped lang="scss">
.documentBox{
	width: 80%;
	margin-left: 30px;
	border: 1px solid #ccc;
	border-radius: 5px;
  overflow: hidden;
	.documentTitle{
    height: 50px;
    line-height: 50px;
    padding: 0 20px;
    background-color:#28262C  ;
    color: #E7DCAE;
		font-size:16px;
	}
  .documentInfo{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 22px;
    padding-bottom: 0;
    .documentText{
      display: flex;
      height: 80px;
      .blurb{
        margin-right: 30px;
      }
      h5{
        margin-bottom: 5px;
      }
      p{
        height: 20px;
        line-height: 20px;
        color: #27252B;
        font-size: 12px;
      }
    }
  }
  /deep/ .tableBox-bg  th{
    height: 48px;
    background: #F0F0F0 ;
    color: #28262C;
  }
	.dataListBox{
    display: flex;
    flex-flow: column;
    justify-content: space-between;
		padding: 20px;
    .height400{
      min-height: 400px;
    }
	}
  .list-no{
    border-top: 1px solid #ccc;
    padding: 200px 0;
    .list-msg{
      margin-bottom: 50px ;
      font-size: 20px;
      font-weight: bold;
    }
  }
}
</style>
